import { useEffect, useState } from 'react'

import { getRequestProviders } from '../../../../api'
import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'

import { REQUEST_PROVIDERS_EMPTY_DATA } from './useRequestProfileProvidersData.constants'
import { canViewRequestProfileProviders } from './useRequestProfileProvidersData.utils'

export function useRequestProfileProvidersData({ outboundUuid, requestData }) {
  const [requestProviders, setRequestProviders] = useState(
    REQUEST_PROVIDERS_EMPTY_DATA
  )

  const requestId = requestData?.id

  const canViewProviders = canViewRequestProfileProviders(
    requestData?.permissions
  )

  async function handleLoadRequestProviders() {
    if (!requestId || (!canViewProviders && !outboundUuid)) {
      return null
    }

    return getRequestProviders({ id: requestId, outboundUuid })
      .then(response => {
        setRequestProviders({
          contractors: response?.data?.contractors || EMPTY_LIST,
          permissions: response?.data?.permissions || EMPTY_OBJECT,
          workers: response?.data?.workers || EMPTY_LIST,
        })
      })
      .catch(() => {
        setRequestProviders(REQUEST_PROVIDERS_EMPTY_DATA)
      })
  }

  useEffect(() => {
    handleLoadRequestProviders()
  }, [canViewProviders, outboundUuid, requestId])

  return { handleLoadRequestProviders, requestProviders }
}
